// extracted by mini-css-extract-plugin
export default {"wrapper":"AssessmentPanelFragmentName_wrapper__3bKoX","deleteButton":"AssessmentPanelFragmentName_deleteButton__L49Zg","input":"AssessmentPanelFragmentName_input__OTphw"};